import { useEffect, useRef, useState } from "react";

export function useRealtime(rid, onEvent, types) {
  const [connected, setConnected] = useState(false);
  const cb = useRef(onEvent);
  cb.current = onEvent;
  useEffect(() => {
    if (!rid) return undefined;
    let ws, timer, closed = false;
    const connect = () => {
      const token = localStorage.getItem("mo_token");
      const base = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws");
      ws = new WebSocket(`${base}/api/ws/${rid}?token=${token}`);
      ws.onopen = () => setConnected(true);
      ws.onmessage = (e) => {
        try {
          const msg = JSON.parse(e.data);
          if (msg.type === "ping") { ws.send("pong"); return; }
          if (!types || types.includes(msg.type)) cb.current?.(msg);
        } catch { /* ignore */ }
      };
      ws.onclose = () => { setConnected(false); if (!closed) timer = setTimeout(connect, 2500); };
      ws.onerror = () => ws.close();
    };
    connect();
    return () => { closed = true; clearTimeout(timer); ws?.close(); };
  }, [rid]); // eslint-disable-line
  return connected;
}

export function LiveDot({ connected }) {
  return (
    <span data-testid="live-indicator" title={connected ? "Live" : "Offline"} className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-500">
      <span className={`h-2 w-2 rounded-full ${connected ? "bg-emerald-500 animate-pulse" : "bg-slate-300"}`} />{connected ? "LIVE" : "..."}
    </span>
  );
}
